import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as giftListActions from "../../actions";
import ModalPopover from "./../../../../../../components/ZUILib/ModalPopover";
import Image from "./../../../../../../components/ZUILib/Image";
import ProgressBar from "../../../../../../components/ZUILib/ProgressBar";
import commonUtil from "../../../../../../utils/commonUtil";
import * as defaultConst from "../../../../../../utils/clientConstant";

const { getTrackOrder } = giftListActions;

const eventTypes = [
  defaultConst.eventType.Aniversario,
  defaultConst.eventType.Cumpleanos,
  defaultConst.eventType.Despedida,
  defaultConst.eventType.Fiesta_Infantil,
  defaultConst.eventType.Fiesta_Reunion,
  defaultConst.eventType.Open_House,
  defaultConst.eventType.Others,
  defaultConst.eventType.Mascotas,
];
class ProductDetails extends Component {
  stage1class = "titleOrder";
  stage2class = "titleOrder";
  stage3class = "titleOrder";
  stage4class = "titleOrder";
  trackOrder = (giftDetail) => {
    // this.props.getTrackOrder(this.props.eventId, giftDetail.purchaseItemId, '20237586');
    this.props
      .getTrackOrder(
        this.props.eventId,
        giftDetail.purchaseItemId,
        giftDetail.pedidoNo
      )
      .then((response) => {
        if (response.status === "success") {
          this.trackingModalCompras.handleShow();
        } else {
          this.trackingFailureModal.handleShow();
        }
      });
  };
  confirmAction = () => {
    this.trackingFailureModal.handleHide();
  };
  closeTrackModal = () => {
    this.trackingModalCompras.handleHide();
  };
  render() {
    const { lables } = this.props;
    const selectedProduct = this.props.selectedProduct;
    const modalLinkForTracker = (
      <span className="status" onClick={() => this.trackOrder(selectedProduct)}>
        {selectedProduct.deliveryStatus}
      </span>
    );
    const _imgsrcTracker = [
      {
        srcSet: selectedProduct.imageURL,
      },
    ];
    const imageAttrTracker = {
      id: "img1",
      src: selectedProduct.imageURL,
      className: "thumb",
      width: "100%",
      altImg: commonUtil.getAssetURL() + "/images/guest/no-image.png",
    };
    const modalHeaderForTracker = (
      <div className="row">
        <div className="col-xs-9">
          {" "}
          <span className="titleOptionModal">
            {commonUtil.getLabel(
              lables.EventAdminPage,
              "adminpage.comparas.delivery.tracking.label"
            )}
          </span>
        </div>
        <div
          className="col-xs-3 text-right closeOptionModal"
          onClick={this.closeTrackModal}
        >
          {commonUtil.getLabel(
            lables.EventAdminPage,
            "adminpage.comparas.close.by.label"
          )}
          <span className="iClass icon-cerrar" aria-hidden="true" />
        </div>
      </div>
    );
    const trackInfo = this.props.trackOrderInfo;
    const trackOrderURL =
      trackInfo &&
      trackInfo.orderTrackInfo &&
      trackInfo.orderTrackInfo.tplRedirectionURL &&
      trackInfo.orderTrackInfo.trackingNumber
        ? trackInfo.orderTrackInfo.tplRedirectionURL +
          trackInfo.orderTrackInfo.trackingNumber
        : "";
    if (
      trackInfo &&
      trackInfo.orderTrackInfo &&
      trackInfo.orderTrackInfo.stageLevel
    ) {
      if (trackInfo.orderTrackInfo.stageLevel === "Stage1") {
        this.progressBar = 1;
        this.stage1class = "titleGreenOrder";
      } else if (trackInfo.orderTrackInfo.stageLevel === "Stage2") {
        this.progressBar = 2;
        this.stage1class = "titleGreenOrder";
        this.stage2class = "titleGreenOrder";
      } else if (trackInfo.orderTrackInfo.stageLevel === "Stage3") {
        this.progressBar = 3;
        this.stage1class = "titleGreenOrder";
        this.stage2class = "titleGreenOrder";
        this.stage3class = "titleGreenOrder";
      } else {
        this.progressBar = 4;
        this.stage1class = "titleGreenOrder";
        this.stage2class = "titleGreenOrder";
        this.stage3class = "titleGreenOrder";
        this.stage4class = "titleGreenOrder";
      }
    }

    return (
      <div className="home-container">
        <div className="row">
          <div className="col-xs-12">
            <table className="tableDetailProduct">
              <tbody>
                <tr>
                  <td>
                    <p className="content fontSize16">
                      {selectedProduct.displayName}
                    </p>
                    <p className="contentSku">
                      {commonUtil.getLabel(
                        lables.EventAdminPage,
                        "adminpage.comparas.sku.by.label"
                      )}
                      :{" "}
                      <span className="secondaryContent">
                        {selectedProduct.skuId}
                      </span>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p className="content">
                      {commonUtil.getLabel(
                        lables.EventAdminPage,
                        "adminpage.comparas.date.label"
                      )}
                      :
                      {selectedProduct.purchaseInfo ? (
                        <span className="secondaryContent">
                          {selectedProduct.purchaseInfo.dateofPurchase}
                        </span>
                      ) : (
                        ""
                      )}
                    </p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p className="content">
                      {commonUtil.getLabel(
                        lables.EventAdminPage,
                        "adminpage.regalosrecibidos.warehouse.label"
                      )}
                      :
                      {selectedProduct.purchaseInfo ? (
                        <span className="secondaryContent">
                          {" "}
                          {selectedProduct.purchaseInfo.warehouseInfo}
                        </span>
                      ) : (
                        ""
                      )}
                    </p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p className="content">
                      {commonUtil.getLabel(
                        lables.EventAdminPage,
                        "adminpage.comparas.delivery.address.label"
                      )}
                      :&nbsp;{" "}
                      {selectedProduct.purchaseInfo &&
                      selectedProduct.modeofDelivery === "physical" ? (
                        <span className="secondaryContent">
                          {selectedProduct.purchaseInfo.deliveryAddress}
                        </span>
                      ) : (
                        "-"
                      )}
                    </p>
                  </td>
                </tr>
                <tr>
                  <td>
                    {this.props.compareEventStatus(
                      selectedProduct.deliveryStatus,
                      "Estatus de entrega"
                    ) ? (
                      <p className="content">
                        {commonUtil.getLabel(
                          lables.EventAdminPage,
                          "adminpage.comparas.delivery.tracking.label"
                        )}
                        :{modalLinkForTracker}
                      </p>
                    ) : (
                      <React.Fragment>
                        {this.props.compareEventStatus(
                          selectedProduct.deliveryStatus,
                          "Regalo electronico"
                        ) ||
                        this.props.compareEventStatus(
                          selectedProduct.deliveryStatus,
                          "Entregado en tienda"
                        ) ? (
                          <span className="status txt-deco-none">
                            {selectedProduct.deliveryStatus}
                          </span>
                        ) : (
                          <span className="secondaryContent">
                            {selectedProduct.deliveryStatus}
                          </span>
                        )}
                      </React.Fragment>
                    )}
                  </td>
                </tr>
                <tr>
                  {!this.props.compareEventStatus(
                    this.props.eventType,
                    eventTypes
                  ) ? (
                    <td>
                      <p className="content">
                        {commonUtil.getLabel(
                          lables.EventAdminPage,
                          "adminpage.comparas.bonus.label"
                        )}
                        : &nbsp;
                        {selectedProduct.bonusInfo === "true" ? (
                          <i
                            className="icon-check confirmCheck"
                            aria-hidden="true"
                          />
                        ) : (
                          <i
                            className="icon-tache disableCheck"
                            aria-hidden="true"
                          />
                        )}
                      </p>
                      {selectedProduct.bonusInfo === "false" ? (
                        <p className="secondaryContent">
                          {selectedProduct.bonusMessage}
                        </p>
                      ) : null}
                    </td>
                  ) : (
                    ""
                  )}
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        {/* Modal for tracker */}
        <ModalPopover
          headerData={modalHeaderForTracker}
          ref={(trackingModalCompras) =>
            (this.trackingModalCompras = trackingModalCompras)
          }
          modalId="tracingModal"
          isModal="true"
          dismiss="false"
        >
          <div className="row grayContent productDet">
            <div className="col-xs-12">
              <div className="col-xs-4">
                <div className="imgProduct">
                  <Image
                    imageAttr={imageAttrTracker}
                    _imgsrc={_imgsrcTracker}
                  />
                </div>
              </div>
              <div className="col-xs-8">
                <p className="nameProduct textToBold">
                  {trackInfo &&
                  trackInfo.orderTrackInfo &&
                  trackInfo.orderTrackInfo.productName
                    ? trackInfo.orderTrackInfo.productName
                    : selectedProduct.displayName}
                </p>
                <p>
                  {commonUtil.getLabel(
                    lables.EventAdminPage,
                    "adminpage.comparas.qty.label"
                  )}
                  :{" "}
                  {trackInfo &&
                  trackInfo.orderTrackInfo &&
                  trackInfo.orderTrackInfo.quantity
                    ? parseInt(trackInfo.orderTrackInfo.quantity, 10)
                    : selectedProduct.quantity}
                </p>
                <p className="dateTitle">
                  {commonUtil.getLabel(
                    lables.EventAdminPage,
                    "adminpage.comparas.deadline.label"
                  )}
                  :
                </p>
                <p className="dateDeliver">
                  {trackInfo &&
                  trackInfo.orderTrackInfo &&
                  trackInfo.orderTrackInfo.estimatedDeliveryDate
                    ? commonUtil.formatDate(
                        commonUtil.formatServiceDate(
                          trackInfo.orderTrackInfo.estimatedDeliveryDate
                        ),
                        "monthName"
                      )
                    : ""}
                </p>
              </div>
            </div>
          </div>
          <div className="row grayContent pt10">
            <div className="col-xs-2" style={{ display: "inline-block" }}>
              <div className="col-xs-2">
                <ProgressBar
                  percent={50}
                  width={20}
                  stages={4}
                  channel="wap"
                  completedStages={this.progressBar}
                />
              </div>
            </div>
            <div className="col-xs-10" style={{ display: "inline-block" }}>
              <ul className="progressDeliver">
                <li>
                  <p className={this.stage1class}>
                    {trackInfo &&
                    trackInfo.orderTrackInfo &&
                    trackInfo.orderTrackInfo.stage1Status
                      ? trackInfo.orderTrackInfo.stage1Status
                      : ""}
                  </p>

                  <p className="subOrder">
                    {trackInfo &&
                    trackInfo.orderTrackInfo &&
                    trackInfo.orderTrackInfo.stage1Date ? (
                      trackInfo.orderTrackInfo.stage1Date
                    ) : (
                      <br />
                    )}
                  </p>
                </li>
                <li>
                  <p className={this.stage2class}>
                    {trackInfo &&
                    trackInfo.orderTrackInfo &&
                    trackInfo.orderTrackInfo.stage2Status
                      ? trackInfo.orderTrackInfo.stage2Status
                      : ""}
                  </p>
                  <p className="subOrder">
                    {trackInfo &&
                    trackInfo.orderTrackInfo &&
                    trackInfo.orderTrackInfo.stage2Date ? (
                      trackInfo.orderTrackInfo.stage2Date
                    ) : (
                      <br />
                    )}
                  </p>
                </li>
                <li>
                  <p className={this.stage3class}>
                    {trackInfo &&
                    trackInfo.orderTrackInfo &&
                    trackInfo.orderTrackInfo.stage3Status
                      ? trackInfo.orderTrackInfo.stage3Status
                      : ""}
                  </p>
                  <p className="subOrder">
                    {trackInfo &&
                    trackInfo.orderTrackInfo &&
                    trackInfo.orderTrackInfo.stage3Date ? (
                      trackInfo.orderTrackInfo.stage3Date
                    ) : (
                      <br />
                    )}
                  </p>
                </li>
                <li>
                  <p className={this.stage4class}>
                    {trackInfo &&
                    trackInfo.orderTrackInfo &&
                    trackInfo.orderTrackInfo.stage4Status
                      ? trackInfo.orderTrackInfo.stage4Status
                      : ""}
                  </p>
                  <p className="subOrder">
                    {trackInfo &&
                    trackInfo.orderTrackInfo &&
                    trackInfo.orderTrackInfo.stage4Date ? (
                      trackInfo.orderTrackInfo.stage4Date
                    ) : (
                      <br />
                    )}
                  </p>
                </li>
              </ul>
            </div>
          </div>

          {trackInfo &&
          trackInfo.orderTrackInfo &&
          trackInfo.orderTrackInfo.trackingNumber !== "" ? (
            <div className="col-md-12 col-sm-12 footerTlo">
              <p>
                {commonUtil.getLabel(
                  lables.EventAdminPage,
                  "adminpage.comparas.shipping.dhl.by.label"
                )}{" "}
                -{" "}
                <span>
                  {commonUtil.getLabel(
                    lables.EventAdminPage,
                    "adminpage.comparas.guide.number.by.label"
                  )}
                  :{" "}
                  <a href={trackOrderURL}>
                    {trackInfo &&
                    trackInfo.orderTrackInfo &&
                    trackInfo.orderTrackInfo.trackingNumber
                      ? trackInfo.orderTrackInfo.trackingNumber
                      : ""}
                  </a>
                </span>
              </p>
            </div>
          ) : null}
        </ModalPopover>

        <ModalPopover
          modalId="sharingModal"
          isModal="true"
          modalClass="confirmationModalPopup"
          ref={(trackingFailureModal) =>
            (this.trackingFailureModal = trackingFailureModal)
          }
          handleOutsideClick
        >
          <div className="row text-align-center">
            <div className="col-xs-12">
              <p>
                {commonUtil.getLabel(
                  lables.EventAdminPage,
                  "adminpage.recibidos.track.order.failure.message"
                )}
              </p>
            </div>
            <div className="col-xs-12">
              <div className="modal-btn-container">
                <div className="pt10 pb10">
                  <a
                    className="btn-link"
                    value="accept"
                    onClick={this.confirmAction}
                  >
                    OK
                  </a>
                </div>
              </div>
            </div>
          </div>
        </ModalPopover>
      </div>
    );
  }
}
const mapStateToProps = (state) => ({
  trackOrderInfo: state.giftList.data.trackOrderInfo,
  eventType:
    state.giftList &&
    state.giftList.data &&
    state.giftList.data.eventSummaryInfo &&
    state.giftList.data.eventSummaryInfo.eventInfo &&
    state.giftList.data.eventSummaryInfo.eventInfo.eventType,
});
const matchDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getTrackOrder,
    },
    dispatch
  );

export default connect(mapStateToProps, matchDispatchToProps)(ProductDetails);
